import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Tooltip from "react-tooltip";
import _ from "lodash";
import Overlay from "../Overlay";
import Button from "../common/Button";
import { formatNumber, numberToOrdinal } from "../../helpers/common.helper";
import TenderingDetailContext from "../../pages/TenderingPage/context";

// const assetsUri = import.meta.env.ASSETS_URI;

const PaymentPrompt = ({ onClose, onConfirm }) => {
  const { paymentTerms } = useContext(TenderingDetailContext);

  const payments =
    paymentTerms?.reduce((prev, curr, index) => {
      if (!paymentTerms[0].paid && prev.length === 2) return prev;
      if (paymentTerms[0].paid && prev.length === 1) return prev;

      if (!curr.paid) {
        let termName = "Final";

        if (index === 0) {
          termName = "Advanced";
        }

        if (index > 0 && index < paymentTerms.length - 2) {
          termName = numberToOrdinal(index);
        }

        return prev.concat({
          ...curr,
          termNo: index,
          termName,
          total: curr.subTotal ?? curr.total,
        });
      }

      return prev;
    }, []) ?? [];

  const grandTotal = payments.reduce((prev, curr) => {
    return prev + curr.total;
  }, 0);

  const paymentNamesToPay =
    payments.map((p) => p.termName).join(" and ") +
    ` payment${payments.length > 1 ? "s" : ""}`;

  return (
    <Overlay onClose={onClose}>
      <div className="tendering-detail__payment-prompt">
        <section className="tendering-detail__payment-prompt__header">
          <span className="tendering-detail__payment-prompt__header__title">
            Proceed with Payment
          </span>
        </section>
        <p style={{ margin: 0 }}>
          <span>You must pay </span>
          <b style={{ fontWeight: 500 }}>{formatNumber(grandTotal, "THB")}</b>
          <span> for {paymentNamesToPay} before starting the next process</span>
        </p>
        <div className="tendering-detail__payment-prompt__footer">
          <Button
            label="Cancel"
            variant={"secondary"}
            size="small"
            onClick={onClose}
          />
          <Button label="Proceed" size="small" onClick={onConfirm} />
        </div>
      </div>
      <Tooltip.Tooltip id="status-hint" />
    </Overlay>
  );
};

PaymentPrompt.propTypes = {};

export default PaymentPrompt;
